import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { TIMEOUT_AXIOS_REQUEST } from 'common/constants';
import { store } from 'v3/data/store';
import { hideLoading, showLoading } from 'v3/data/store/loading/actions';
import { setCookiesToHeaders } from 'v3/services/utils/set-cookies-to-headers';

const IS_PROXY = import.meta.env.VITE_IS_PROXY === 'true';
const BASE_URL = IS_PROXY
  ? import.meta.env.VITE_IN_APP_API_BASE_URL_PROXY_REVERSE
  : import.meta.env.VITE_IN_APP_API_BASE_URL;

const onlineApi = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT_AXIOS_REQUEST,
});

onlineApi.interceptors.response.use(
  (response: AxiosResponse) => {
    hideLoading();
    return response;
  },
  (error) => {
    hideLoading();
    return Promise.reject(error);
  },
);

onlineApi.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const { storeUserId } = store.getState().store.storeSelected;
    config.headers['storeId'] = storeUserId;
    const bypassLoading = Boolean(config.headers?.['x-bypass-loading']);

    if (!bypassLoading) {
      showLoading();
    }
    return setCookiesToHeaders(config);
  },
  (error) => {
    hideLoading();
    return Promise.reject(error);
  },
);

export default onlineApi;
